<template>
  <div>
    <v-card v-if="mode === 'login'">
      <v-card-title class="title">Log In</v-card-title>
      <v-card-text>
        <v-text-field label="Email"
                      v-model="email"
                      id="login-email"
        />

        <v-text-field type="password"
                      label="Password"
                      v-model="password"
                      id="login-password"
        />
      </v-card-text>
      <v-card-actions>
        <v-layout column>
          <v-layout>
            <v-btn color="primary" class="mx-0 px-0" @click="signIn">Log In</v-btn>
            <v-spacer />
            <v-btn flat class="accent--text"
                   @click="$store.dispatch('applications/hideSessionModal')">Cancel</v-btn>
          </v-layout>
          <v-layout>
            <v-menu>
              <v-btn slot="activator"
                     flat small class="mx-0 px-0 mt-2">
                Advanced Login
              </v-btn>
              <v-list>
                <v-list-tile @click="googleSignIn">
                  <v-list-tile-content class="align-center">
                    <img height="30" src="/static/icon-40px.png">
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-spacer />
            <v-btn flat small class="mx-0 px-0 mt-2"
                   color="primary"
                   @click="mode = 'password'">Forgot password?</v-btn>
          </v-layout>
        </v-layout>
      </v-card-actions>
    </v-card>

    <v-card v-else>
      <v-card-title class="title">Reset your password</v-card-title>
      <v-card-text>
        <v-text-field label="Enter your email address"
                      v-model="resetEmail"
                      :error-messages="errors.first('email')"
                      data-vv-as="Email address"
                      data-vv-name="email"
                      v-validate="'required|email'">
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="sendEmail()">Send reset email</v-btn>
        <v-spacer />
        <v-btn flat @click="mode = 'login'">Back to Login</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'LoginForm',
  data: () => ({
    email: '',
    password: '',
    mode: 'login',
    resetEmail: null,
  }),
  methods: {
    async sendEmail() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        try {
          await firebase.auth().sendPasswordResetEmail(this.resetEmail);

          this.$store.dispatch('applications/setSuccessNotification', {
            message: 'Email sent!',
          });
        } catch (error) {
          this.$store.dispatch('applications/setErrorNotification', {
            message: error.message,
          });
        } finally {
          this.mode = 'login';
        }
      }
    },
    googleSignIn() {
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.setCustomParameters({
        prompt: 'select_account',
      });
      provider.addScope('profile');
      provider.addScope('email');
      firebase.auth().signInWithPopup(provider).then(() => {
        try {
          this.$emit('success');
        } catch (error) {
          this.$store.dispatch('applications/setErrorNotification', {
            message: error.message,
          });
        }
      }).catch((error) => {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      });
    },
    async signIn() {
      firebase.auth()
        .signInWithEmailAndPassword(this.email, this.password).then(async () => {
          try {
            this.$emit('success');
          } catch (error) {
            this.$store.dispatch('applications/setErrorNotification', {
              message: error.message,
            });
          }
        }).catch((error) => {
          this.$store.dispatch('applications/setErrorNotification', {
            message: error.message,
          });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/LoginForm.vue